import { Flex } from "@chakra-ui/react";
import { Spin } from "antd";
import {
  Accordion,
  AccordionItem,
  AccordionPanel,
  AccordionButton,
  AccordionIcon,
} from "@chakra-ui/react";
import { Tree, Row, Col, Checkbox } from "antd";
import { useEffect, useRef } from "react";
import { useCondominiosLiberados } from "core/features/tenants/hooks";
import colors from "core/resources/theme/colors";

export interface InputCondominiosLiberadosProps {
  onChange: (ids: string[]) => void;
  value: string[];
  readonly?: boolean;
  tenantId: string;
}

export const InputCondominiosLiberados = ({
  onChange,
  value,
  readonly,
  tenantId,
}: InputCondominiosLiberadosProps) => {
  const valueRef = useRef(value ?? []);
  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  const { data, isLoading } = useCondominiosLiberados(tenantId);

  const onCheck = (checkedKeysValue: string[]) => {
    onChange(checkedKeysValue);
  };

  const checkAll = value.length === data?.length;

  return (
    <>
      {isLoading ? (
        <Flex alignItems="center" justifyContent="center">
          <Spin size="large" spinning />
        </Flex>
      ) : null}

      {!isLoading && data?.length ? (
        <Flex flexDir={"column"} gap="16px">
          <Accordion defaultIndex={undefined} allowMultiple allowToggle>
            <Row gutter={32}>
              <Col sm={24}>
                <AccordionItem rounded="8px" bg="white" mb={2}>
                  <AccordionButton _hover={{ bg: "transparent" }}>
                    <Flex
                      fontSize="14px"
                      flex="1"
                      textAlign="left"
                      alignItems="center"
                    >
                      <Checkbox
                        checked={checkAll}
                        disabled={readonly}
                        indeterminate={
                          data?.some((child) => value?.includes(child.key)) &&
                          !checkAll
                        }
                        onClick={(ev) => {
                          ev.stopPropagation();
                        }}
                        onChange={(ev) => {
                          if (checkAll) {
                            onChange([]);
                          } else {
                            onChange(data?.map((item) => item.key) ?? []);
                          }
                          // if (!ev.target.checked) {
                          //   checkedKeys[0] = checkedKeys[0]?.filter(
                          //     (check) => ![].includes(check)
                          //   );

                          //   onCheck(checkedKeys[0] ?? [], 0);
                          // } else {
                          //   const nextValue = _.union(checkedKeys[0], []);

                          //   onCheck(nextValue, 0);
                          // }
                        }}
                      />
                      <Flex
                        fontWeight="medium"
                        fontSize="16px"
                        flex={1}
                        pl="12px"
                        color={colors.black900}
                        as="p"
                      >
                        Acessos Liberados
                      </Flex>
                      <Flex as="p">
                        {value.length ?? 0}/{data?.length ?? 0}{" "}
                      </Flex>
                    </Flex>
                    <AccordionIcon />
                  </AccordionButton>

                  <AccordionPanel>
                    <Tree
                      checkable
                      disabled={readonly}
                      onCheck={(v) => {
                        onCheck(v as string[]);
                      }}
                      checkedKeys={value ?? []}
                      treeData={data ?? []}
                    />
                  </AccordionPanel>
                </AccordionItem>
              </Col>
            </Row>
          </Accordion>
        </Flex>
      ) : null}
    </>
  );
};

export default InputCondominiosLiberados;
